// extracted by mini-css-extract-plugin
module.exports = {"container":"frequent-contact_container__3Aawx","icon":"frequent-contact_icon__31ClQ","text":"frequent-contact_text__2X3dK"};